import React, { useRef, useState } from 'react';
import { Form, notification, Spin } from 'antd';
import { peopleApi, endpoints } from '@/config';
import UploadFormBody from './components/UploadFormBody';
import UploadStatus from './components/UploadStatus';
import UploadPreview from './components/UploadPreview';
import commonwords from '@/utils/commonwords';
import UploadError from '@/components/People/UploadPeople/components/UploadError';
import { connect } from 'react-redux';
import { fetchPeople } from '@/store/people/actions';
import { fetchGroupPeople } from '@/store/groups/actions';
import { injectIntl } from 'react-intl';

const averageTimePerByte = 0.065; //ms
const checkInterval = 12000; //ms
function UploadFileUi({
  onClose,
  intl,
  form,
  location,
  fetchedGroupId,
  groups,
  fetchPeople,
  fetchGroupPeople,
  userId,
  siteLanguage,
  peopleLimit,
}) {
  const [showPreview, setShowPreview] = useState(false);
  const [file, setFile] = useState();
  const [fileHasError, setFileHasError] = useState(false);
  //upload
  const [percent, setPercent] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const estimatedTime = useRef(0);
  const [fileRef, setFileRef] = useState();
  const [checkCount, setCheckCount] = useState(0);

  //checks Upload Status
  React.useEffect(() => {
    if (!isUploading || !fileRef || percent === 100) return;
    const timer = setTimeout(() => {
      peopleApi
        .get({ url: `${endpoints.personUploads}/${fileRef}/Status` })
        .then(result => {
          if (result.status === 'ongoing') {
            if (percent >= 97) return;
            let newPercent = Math.floor(
              (checkInterval * checkCount * 100) / estimatedTime.current
            );
            if (newPercent >= 80 && newPercent - percent > 1) {
              newPercent = percent + 1; //from 80% , should not increase by more than one. to avoid long wait time at 97%
            }
            setPercent(
              newPercent > 1 ? (newPercent < 97 ? newPercent : 97) : 1
            );
            setCheckCount(checkCount + 1);
          } else if (result.status === 'completed') {
            setPercent(100);
          } else {
            setIsUploading(false);
            setFileRef(undefined);
            setPercent(0);
            setCheckCount(0);
            notification.success({
              message: intl.formatMessage(commonwords['Success']),
              description: 'Upload Successful',
            });
          }
        })
        .catch(e => {
          setCheckCount(checkCount + 1);
        });
    }, checkInterval);
    return () => clearTimeout(timer);
  }, [isUploading, fileRef, checkCount]);

  // new
  const uploadFile = () => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    let groupId = form.getFieldValue('groupId');
    if (groupId) formData.append('groupId', groupId);
    let group = groups.find(g => g.uuid === groupId);
    if (group) formData.append('groupName', group.name);
    peopleApi
      .post({
        url: endpoints.personUploads,
        body: formData,
        contentType: 'multipart/form-data',
        shouldResolve: false,
      })
      .then(res => {
        const result = res.data;
        if (result.status === 200) {
          estimatedTime.current = file.size * averageTimePerByte;
          setPercent(1);
          setFileRef(result.file_ref);
        } else if (result.status === 403) {
          setIsUploading(false);
          setFileHasError(true);
        } else {
          throw Error('failed');
        }
      })
      .catch(err => {
        setIsUploading(false);
        notification.error({
          message: intl.formatMessage(commonwords['Failed']),
          description: 'Something went wrong',
        });
      });
  };

  const onComplete = () => {
    let groupId = form.getFieldValue('groupId');
    if (location.pathname.includes('/everyone')) {
      fetchPeople(userId, peopleLimit, 1, intl, siteLanguage);
    } else if (groupId && groupId === fetchedGroupId) {
      fetchGroupPeople(groupId, userId, intl, siteLanguage);
    }
    onClose();
  };
  // submit function
  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err && file) {
        setShowPreview(true);
      }
    });
  };

  console.log(groups, 'groups');
  return (
    <Spin spinning={isUploading && percent === 0}>
      <div style={{ position: 'relative', paddingTop: '50px' }}>
        <div
          id={'OverLayWrapper'}
          className={
            showPreview || (isUploading && percent !== 0) || fileHasError
              ? 'active'
              : ''
          }
        >
          {isUploading && percent !== 0 && (
            <UploadStatus onClose={onComplete} percent={percent} />
          )}
          {fileHasError && <UploadError onOk={() => setFileHasError(false)} />}
          {showPreview && (
            <UploadPreview
              onCancel={() => setShowPreview(false)}
              file={file}
              onOk={() => {
                setShowPreview(false);
                uploadFile();
              }}
            />
          )}
        </div>
        <Form onSubmit={handleSubmit}>
          <UploadFormBody
            fetchedGroupId={fetchedGroupId}
            groups={groups}
            onClose={onClose}
            location={location}
            form={form}
            file={file}
            setFile={setFile}
          />
        </Form>
      </div>
    </Spin>
  );
}

const UploadForm = Form.create()(UploadFileUi);
const mapStateToProps = state => ({
  groups: state.groups.groups,
  fetchedGroupId: state.groups.fetchedGroupId,
  siteLanguage: state.intl.siteLanguage,
  userId: state.user.userId,
  peopleLimit: state.people.peopleLimit,
});
const mapDispatchToProps = dispatch => ({
  fetchPeople: (userId, limit, page, intl, siteLanguage) => {
    dispatch(fetchPeople(userId, limit, page, intl, siteLanguage));
  },
  fetchGroupPeople: (groupsId, userId, intl, siteLanguage) => {
    dispatch(fetchGroupPeople(groupsId, userId, intl, siteLanguage));
  },
});
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UploadForm)
);
